import { MembershipFeeAccrualBases } from '../../../utils/classes/graphql'
import {
  ACCRUAL_BASE_TYPE_EUROS,
  ACCRUAL_BASE_TYPE_PERCENTAGE
} from '../constants'

export const getAccrualBaseProps = (accrualBase: MembershipFeeAccrualBases) => {
  let accrualBaseAmount
  let formattedAccrualBaseAmount
  let accrualBaseType

  const type = accrualBase.tyyppi

  if (type === 'PROS') {
    accrualBaseAmount = accrualBase.prosentti?.toString()
    formattedAccrualBaseAmount =
      accrualBaseAmount?.replace('.', ',') + ACCRUAL_BASE_TYPE_PERCENTAGE
  } else if (type === 'EUR') {
    accrualBaseType = ACCRUAL_BASE_TYPE_EUROS
    accrualBaseAmount = accrualBase.summa?.toString()
    formattedAccrualBaseAmount =
      accrualBaseAmount?.replace('.', ',') + ACCRUAL_BASE_TYPE_EUROS
  }

  return { accrualBaseAmount, formattedAccrualBaseAmount, accrualBaseType }
}

export const formatAccrualBaseAmount = (
  accrualBase: MembershipFeeAccrualBases
) => {
  const { formattedAccrualBaseAmount } = getAccrualBaseProps(accrualBase)

  return formattedAccrualBaseAmount
}
